import { baseColors, brandColors, exodusColors } from "./colors";

/**
 * Per-app display config consumed by the app switcher and AccessDenied
 * (name, destination URL, logo, accent dot colour). This does NOT drive
 * app theming — per-app CSS themes live in packages/ui-web/src/styles/themes/.
 */
export const appThemes = {
  bridge: {
    name: "Bridge",
    description: "Facilitator platform for managing groups and programmes",
    url: process.env.NEXT_PUBLIC_BRIDGE_URL || "http://localhost:3002",
    logo: "/logos/bridge-logo.svg",
    primary: brandColors.bridge, // #F59E0B
  },
  circle: {
    name: "Circle",
    description: "Member-facing recovery platform",
    url: process.env.NEXT_PUBLIC_CIRCLE_URL || "http://localhost:3004",
    logo: "/logos/circle-logo.svg",
    primary: brandColors.circle, // #0E8C9C
  },
  habitat: {
    name: "Habitat",
    description: "Rehabilitation facility management platform",
    url: process.env.NEXT_PUBLIC_HABITAT_URL || "http://localhost:3005",
    logo: "/logos/habitat-logo.svg",
    primary: brandColors.habitat, // #C96218
  },
  pulse: {
    name: "Pulse",
    description: "Internal staff operations platform",
    url: process.env.NEXT_PUBLIC_PULSE_URL || "http://localhost:3003",
    logo: "/logos/pulse-logo.svg",
    primary: brandColors.pulse, // #2462BE
  },
  billing: {
    name: "Billing",
    description: "Subscription and payment management platform",
    primary: exodusColors.green.base, // #1A7A3C
  },
  finder: {
    name: "Finder",
    description: "Find recovery groups and meetings near you",
    url: process.env.NEXT_PUBLIC_FINDER_URL || "http://localhost:3010",
    primary: exodusColors.red.base, // #C5412A
  },
  register: {
    name: "Register",
    description: "Public registration and signup portal",
    primary: baseColors.neutral[800], // #262626
  },
  website: {
    name: "Website",
    description: "Project Exodus public website",
    url: process.env.NEXT_PUBLIC_WEBSITE_URL || "http://localhost:3000",
    primary: baseColors.neutral[800],
  },
} as const;

export type AppTheme = keyof typeof appThemes;
